"use strict";
(self["webpackChunkshopify_template"] = self["webpackChunkshopify_template"] || []).push([["klevu"],{

/***/ "./src/js/utils/klevu.js":
/*!*******************************!*\
  !*** ./src/js/utils/klevu.js ***!
  \*******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   fetchSearchQuery: function() { return /* binding */ fetchSearchQuery; },
/* harmony export */   fetchTrendingProducts: function() { return /* binding */ fetchTrendingProducts; },
/* harmony export */   fetchV1Suggestions: function() { return /* binding */ fetchV1Suggestions; },
/* harmony export */   initKlevu: function() { return /* binding */ initKlevu; },
/* harmony export */   renderArticleCard: function() { return /* binding */ renderArticleCard; },
/* harmony export */   renderPageCard: function() { return /* binding */ renderPageCard; },
/* harmony export */   renderProductCard: function() { return /* binding */ renderProductCard; },
/* harmony export */   sanitizedCollectionObject: function() { return /* binding */ sanitizedCollectionObject; },
/* harmony export */   splitResultsByType: function() { return /* binding */ splitResultsByType; }
/* harmony export */ });
/* harmony import */ var _klevu_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @klevu/core */ "./node_modules/@klevu/core/dist/mjs/index.js");


/**
 * Initialize Klevu
 * @param {String} url - Klevu store url
 * @param {String} key - Klevu api key
 */
async function initKlevu(url, key) {
  const defaultSetup = _klevu_core__WEBPACK_IMPORTED_MODULE_0__.KlevuConfig.default;
  if (!url || !key || defaultSetup) return;
  await _klevu_core__WEBPACK_IMPORTED_MODULE_0__.KlevuConfig.init({
    url: `https://${url.toLowerCase().replace('https://', '').split('/')[0]}/cs/v2/search`,
    apiKey: key.toLowerCase()
  });
}

/**
 * Fetch search from Klevu.
 * @param {String} query - Search query.
 * @param {Object} options - Additional query options.
 * @returns {Object}
 */
async function fetchTrendingProducts(options) {
  const fetchedResults = [];
  //const suggestQuery = location.pathname.includes('/products/') || location.pathname.includes('/collections/') ? location.pathname.replace('/all', '/').split('/').pop().replaceAll('-', ' ') : '*';
  const suggestQuery = '*';
  const result = await (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.KlevuFetch)((0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.trendingProducts)(suggestQuery.toLowerCase(), ...options), (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.searchCms)(suggestQuery, {
    id: 'searchCms',
    limit: 100
  }), (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.suggestions)(suggestQuery, {
    id: 'suggestions',
    limit: 10
  }));
  fetchedResults.products = result.queriesById('trendingProducts').records || [];
  fetchedResults.cms = result.queriesById('searchCms').records || [];
  fetchedResults.suggestions = result.suggestionsById('suggestions').suggestions || [];
  return fetchedResults ? fetchedResults : false;
}

/**
 * Fetch search from Klevu.
 * @param {String} query - Search query.
 * @param {Object} options - Additional query options.
 * @returns {Object}
 */
async function fetchSearchQuery(query, options) {
  const fetchedResults = [];
  const result = await (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.KlevuFetch)((0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.search)(query.toLowerCase(), ...options), (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.searchCms)(query, {
    id: 'searchCms',
    limit: 30
  }), (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.suggestions)(query, {
    id: 'suggestions',
    limit: 10
  }), (0,_klevu_core__WEBPACK_IMPORTED_MODULE_0__.sendSearchEvent)());
  fetchedResults.products = result.queriesById('search').records || [];
  fetchedResults.cms = result.queriesById('searchCms').records || [];
  fetchedResults.suggestions = result.suggestionsById('suggestions').suggestions || [];
  fetchedResults.searchResponse = result.queriesById('search');
  fetchedResults.redirects = await result.queriesById('search').getRedirects?.();
  fetchedResults.count = {
    products: result.queriesById('search')?.meta.totalResultsFound || 0,
    cms: result.queriesById('searchCms')?.meta.totalResultsFound || 0
  };
  return fetchedResults ? fetchedResults : false;
}

/**
 * Fetch search term suggestions from v1 API
 */
async function fetchV1Suggestions(key) {
  if (!key) return [];
  const response = await fetch(`https://js.klevu.com/klevu-js-v1/klevu-js-api/${key}.json`);
  if (response.ok) {
    const json = await response.json();
    return json['klevu_webstorePopularTerms'] || [];
  } else {
    return [];
  }
}

/**
 * Splits the search results by their type.
 * @param {Array} records - The array of search results.
 * @param {number} [limit=3] - The maximum number of results per type.
 * @returns {Object} An object containing arrays of results split by type.
 */
function splitResultsByType(records, limit = 10) {
  const articles = [];
  const pages = [];
  records.forEach(record => {
    if (record.type === 'articles' && articles.length < limit) {
      articles.push(record);
    } else if (record.type === 'pages' && pages.length < limit) {
      pages.push(record);
    }
  });
  return {
    articles,
    pages
  };
}

/**
 * Updates product object to match Shopify.
 * @param {Array} collection - Results array.
 * @returns {Array}
 */
function sanitizedCollectionObject(collection) {
  const sanitizedCollection = [...collection].map(product => {
    if (product.typeOfRecord !== _klevu_core__WEBPACK_IMPORTED_MODULE_0__.KlevuTypeOfRecord.Product) return product;
    //if (product.name.includes('[TEST]') && Shopify.devMode) console.log(product);
    const price = Number(product.salePrice) * 100 || Number(product.price) * 100;
    const startPrice = product.startPrice;
    const compareAtPrice = Number(product.price) * 100;
    const quantity = product.min ? parseInt(product.min) : 1;
    return {
      available: product.inStock === 'yes',
      badges: product.hasOwnProperty('badge') ? product.badge.replace(/\[|\]/g, '').split(',').map(item => item.trim()) : null,
      badgeSaving: calculateDiscountPercentage(compareAtPrice, price),
      compareAtPrice: {
        amount: compareAtPrice
      },
      featuredImage: {
        src: product.imageUrl
      },
      handle: product.url.split('/').pop(),
      hasOnlyDefaultVariant: product.totalVariants <= 0,
      secondaryImage: {
        src: product.imageHover === '' ? false : product.imageHover
      },
      id: product.itemGroupId,
      variantId: product.id,
      price: {
        amount: price,
        startPrice: startPrice > 0 ? Number(startPrice) * 100 : false
      },
      quantity: quantity,
      sku: product.sku,
      size: product.size,
      title: product.name,
      url: product.url,
      cardDescription: product.hasOwnProperty('product_card_description') ? product.product_card_description.replace(/\[|\]/g, '') : null,
      shortDescription: product.hasOwnProperty('short_description') ? product.short_description.replace(/\[|\]/g, '') : null,
      reviews: {
        averageRating: product.hasOwnProperty('rating') ? Number(product.rating) : null,
        totalReviews: product.hasOwnProperty('ratingCount') ? product.ratingCount : null,
        iconWidth: product.hasOwnProperty('rating') ? Number(product.rating) / 5 * 100 : null
      },
      usp: product.hasOwnProperty('properties') ? product.properties.replace(/\[|\]/g, '').split(',').map(item => item.trim()) : null,
      ukOnly: parseInt(product.url_only || false),
      isBundle: product.bundle_1 || product.bundle_2 || product.bundle_3,
      dangerous: parseInt(product.dangerous || false),
      min: parseInt(product.min || false),
      max: parseInt(product.max || false)
    };
  });
  return sanitizedCollection;
}

/**
 * Renders a product card with various product details and interactions.
 *
 * @param {Object} product - The product object containing details to render.
 * @returns {string} The HTML string for the product card.
 */
function renderProductCard(product, small = false) {
  return `
    <div data-product data-product-item data-product-id="${product.id}" data-variant-id="${product.variantId}" class="relative w-full h-full bg-product p-offset flex flex-col gap-sm items-stretch group/product ${small ? 'aspect-[5/9]' : 'aspect-[6/9] laptop:aspect-[5/9]'}">
      <a href="${product.url}" class="relative z-10 flex items-start desktop:gap-md tablet:flex-col" tabindex="0">
        <div class="flex flex-col flex-1">
          <div class="text-heading-product">${product.title}</div>
          ${product.cardDescription ? `
            <div class="text-sm block mt-2xs" data-product-summary>
              ${product.cardDescription}
            </div>
          ` : ''}
          ${product.reviews.averageRating ? `
            <div class="relative z-10 text-scheme-text mt-sm">
              <div class="flex items-center gap-2xs text-sm">
                <div class="relative">
                  ${window.strings.icons.rating.stars}
                  <div
                    class="absolute z-10 top-0 bottom-0 left-0 overflow-clip pointer-events-none"
                    style="width:${product.reviews.iconWidth}%"
                  >
                    ${window.strings.icons.rating.starsFill}
                  </div>
                </div>
                <div>
                  ${product.reviews.averageRating}
                </div>
              </div>
            </div>
          ` : ''}
          <div class="empty:hidden relative z-10 flex gap-xs tablet:gap-3xs tablet:w-full mt-sm">
            ${product.compareAtPrice.amount > product.price.amount ? `
              <div class="pointer-events-none text-sm px-xs py-3xs border border-scheme-links text-scheme-links rounded-sm bg-product">                
                ${window.strings.product.save.replace('{{ amount }}', product.badgeSaving)}
              </div>
            ` : product.badges ? `
              ${product.badges.map(badge => `
                <div class="pointer-events-none text-sm px-xs py-3xs border border-scheme-links text-scheme-links rounded-sm bg-product">
                  ${badge}
                </div>
              `).join('')}
            ` : ''}
          </div>
        </div>
      </a>
      <a href="${product.url}" class="flex-1">
        ${product.featuredImage.src === '' ? window.strings.placeholders.product : `<img src="${product.featuredImage.src}" srcset="
        ${Shopify.getSizedImage(product.featuredImage.src, '1000x')} 1000w,
        ${Shopify.getSizedImage(product.featuredImage.src, '900x')} 900w,
        ${Shopify.getSizedImage(product.featuredImage.src, '800x')} 800w,
        ${Shopify.getSizedImage(product.featuredImage.src, '700x')} 700w,
        ${Shopify.getSizedImage(product.featuredImage.src, '600x')} 600w,
        ${Shopify.getSizedImage(product.featuredImage.src, '500x')} 500w,
        ${Shopify.getSizedImage(product.featuredImage.src, '400x')} 400w,p
        ${Shopify.getSizedImage(product.featuredImage.src, '300x')} 300w,
        ${Shopify.getSizedImage(product.featuredImage.src, '200x')} 200w,
        ${Shopify.getSizedImage(product.featuredImage.src, '100x')} 100w" sizes="auto" alt="${product.title}" class="absolute inset-0 z-0 block w-full h-full transition-opacity object-contain">`}
      </a>
      <div class="relative z-10 flex items-end justify-between gap-xs">
        <div class="flex items-center gap-2xs">
          ${product.compareAtPrice.amount > product.price.amount ? `
            <s
              class="text-scheme-light"
              aria-label="${window.strings.was} ${Shopify.formatMoney(product.compareAtPrice.amount, '{{amount_no_decimals}}')}"
            >
              ${Shopify.formatMoney(product.compareAtPrice.amount, Shopify.money_format)}
            </s>` : ''}
          <span class="${product.compareAtPrice.amount === product.price.amount ? 'text-scheme-links' : 'text-red'}">
            ${Shopify.formatMoney(product.price.amount, Shopify.money_format)}
          </span>
        </div>
        <div class="text-scheme-links text-right">
          ${product.size}
        </div>
      </div>
      <div class="relative z-10">
        ${product.ukOnly ? `
          <a tabindex="0" href="https://www.thisworks.com/products/${product.handle}" class="btn btn--secondary ${small && 'py-xs min-h-[40px]'} w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover">
            ${window.strings.product.ukOnly}
          </a>
        ` : product.isBundle ? `
          <a tabindex="0" href="${product.url}" class="btn btn--secondary ${small && 'py-xs min-h-[40px]'} w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover">
            ${product.available ? window.strings.viewProduct : window.strings.soldOutPlp}
          </a>
        ` : product.available ? `
          <product-form data-async>
            <form method="post" action="${Shopify.routes.root}cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
              <input type="hidden" name="id" value="${product.variantId}">
              <input type="hidden" name="quantity" value="${product.quantity || 1}">
              ${product.dangerous ? `<input type="hidden" name="properties[_limit_dangerous]" value="${product.dangerous === 1}">` : ''}
              ${product.min ? `<input type="hidden" name="properties[_limit_min]" value="${product.min}">` : ''}
              ${product.max ? `<input type="hidden" name="properties[_limit_max]" value="${product.max}">` : ''}
              <div class="flex flex-col items-stretch gap-sm">
                <button
                  tabindex="0"
                  type="submit"
                  class="appearance-none transition-all outline-DISABLED-none leading-none disabled:pointer-events-none aria-disabled:pointer-events-none shrink-0  btn ${small && 'py-xs min-h-[40px]'} btn--secondary bg-product w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover"
                  ${product.available || 'disabled'}
                >
                  ${product.available ? window.strings.addToCart : window.strings.soldOutPlp}
                </button>
              </div>
            </form>
          </product-form>
        ` : `
          <ajax-modal
            data-async
            data-view="stock-notifier"
            class="w-full"
          >
            <a tabindex="0" href="${product.url}" class="btn--primary w-full py-xs min-h-[40px]">
              ${window.strings.soldOutPlp || window.strings.outOfStock.button}
            </a>
          </ajax-modal>`}
      </div>
    </div>
  `;
  /* The below is with hover */
  /*
  return `
    <div data-product-id="${product.id}" data-variant-id="${product.variantId}" class="relative w-full h-full bg-product supports-hover:hover:bg-grey-100 transition-colors p-offset flex flex-col gap-sm items-stretch group/product aspect-[6/9] laptop:aspect-[5/9]">
      <a href="${product.url}" class="relative z-10 flex items-start desktop:gap-md tablet:flex-col">
        <div class="flex flex-col gap-2 flex-1">
          <div class="text-heading-product">${product.title}</div>
          ${
            product.cardDescription
              ? `
            <div class="text-sm supports-hover:group-hover/product:hidden block">
              ${product.cardDescription}
            </div>
          `
              : ''
          }
          ${
            product.shortDescription
              ? `
            <div class="text-sm supports-hover:group-hover/product:block hidden">
              ${product.shortDescription}
            </div>
          `
              : ''
          }
          ${
            product.reviews.averageRating
              ? `
            <div class="relative z-10 supports-hover:group-hover/product:hidden text-scheme-text">
              <div class="flex items-center gap-2xs text-sm">
                <div class="relative">
                  ${window.strings.icons.rating.stars}
                  <div
                    class="absolute z-10 top-0 bottom-0 left-0 overflow-clip pointer-events-none"
                    style="width:${product.reviews.iconWidth}%"
                  >
                    ${window.strings.icons.rating.starsFill}
                  </div>
                </div>
                <div>
                  ${product.reviews.averageRating}
                </div>
              </div>
            </div>
          `
              : ''
          }
        </div>
        <!--div class="contents tablet:block absolute top-full right-0 mt-3xs">
          <div class="relative z-10 supports-hover:group-hover/product:hidden flex flex-col gap-xs tablet:gap-3xs tablet:w-full items-end">
            ${
              product.compareAtPrice.amount > product.price.amount
                ? `
              <div class="pointer-events-none w-[70px] h-[70px] tablet:w-[50px] tablet:h-[50px] rounded-full overflow-clip object-cover p-0.5 border border-current text-scheme-links flex items-center justify-center text-center text-sm lowercase tablet:mb-3xs text-balance">                
                ${window.strings.product.save.replace('{{ amount }}', product.badgeSaving).replace(' ', '<br>')}
              </div>
            `
                : product.badges
                  ? `
              ${product.badges
                .map(
                  (badge) => `
                <div class="pointer-events-none w-[70px] h-[70px] tablet:w-[50px] tablet:h-[50px] rounded-full overflow-clip object-cover p-0.5 border border-current text-scheme-links flex items-center justify-center text-center text-sm lowercase tablet:mb-3xs text-balance">
                  ${badge}
                </div>
              `
                )
                .join('')}
            `
                  : ''
            }
          </div>
        </div-->
      </a>
      <a href="${product.url}" class="flex-1">
        ${
          product.secondaryImage.src
            ? `
          <img src="${product.featuredImage.src}" alt="${product.title}" class="absolute inset-0 z-0 block w-full h-full transition-opacity supports-hover:group-hover/product:opacity-0 opacity-100 object-contain">
          <img src="${product.secondaryImage.src}" alt="${product.title}" class="absolute inset-0 z-0 block w-full h-full transition-opacity supports-hover:group-hover/product:opacity-100 opacity-0 object-contain">
        `
            : `
          ${product.featuredImage.src === '' ? window.strings.placeholders.product : `<img src="${product.featuredImage.src}" alt="${product.title}" class="absolute inset-0 z-0 block w-full h-full transition-opacity object-contain">`}
        `
        }
      </a>
      <div class="relative z-10 flex items-end justify-between gap-xs ${product.usp ? 'supports-hover:group-hover/product:hidden' : ''}">
        <div class="flex items-center gap-2xs">
          ${
            product.compareAtPrice.amount > product.price.amount
              ? `
            <s
              class="text-scheme-light"
              aria-label="${window.strings.was} ${Shopify.formatMoney(product.compareAtPrice.amount, '{{amount_no_decimals}}')}"
            >
              ${Shopify.formatMoney(product.compareAtPrice.amount, Shopify.money_format)}
            </s>`
              : ''
          }
          <span class="${product.compareAtPrice.amount === product.price.amount ? 'text-scheme-links' : 'text-red'}">
            ${Shopify.formatMoney(product.price.amount, Shopify.money_format)}
          </span>
        </div>
        <div class="text-scheme-links text-right">
        </div>
      </div>
      ${
        product.usp
          ? `
        <ul class="relative z-10 supports-hover:group-hover/product:flex hidden flex-col gap-3xs text-scheme-links">
          ${product.usp
            .map(
              (item) => `
            <li>
              ${item}
            </li>
          `
            )
            .join('')}
        </ul>
      `
          : ''
      }
      <div class="relative z-10">
        ${
          product.ukOnly
            ? `
          <a href="https://www.thisworks.com/products/${product.handle}" class="btn btn--secondary ${small && 'py-xs min-h-[40px]'} w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover">
            ${window.strings.product.ukOnly}
          </a>
        `
            : product.isBundle
              ? `
          <a href="${product.url}" class="btn btn--secondary ${small && 'py-xs min-h-[40px]'} w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover">
            ${product.available ? window.strings.viewProduct : window.strings.soldOutPlp}
          </a>
        `
              : `
          <product-form data-async>
            <form method="post" action="${Shopify.routes.root}cart/add" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data">
              <input type="hidden" name="id" value="${product.variantId}">
              <input type="hidden" name="quantity" value="${product.quantity || 1}">
              <div class="flex flex-col items-stretch gap-sm">
                <button
                  type="submit"
                  class="appearance-none transition-all outline-DISABLED-none leading-none disabled:pointer-events-none aria-disabled:pointer-events-none shrink-0  btn ${small && 'py-xs min-h-[40px]'} btn--secondary bg-product w-full supports-hover:group-hover/product:bg-btn-background-hover supports-hover:group-hover/product:border-btn-border-hover supports-hover:group-hover/product:text-btn-text-hover"
                  ${product.available || 'disabled'}
                >
                  ${product.available ? window.strings.addToCart : window.strings.soldOutPlp}
                </button>
              </div>
            </form>
          </product-form>
        `
        }
      </div>
    </div>
  `;
  */
}

/**
 * Renders an article card with various article details and interactions.
 *
 * @param {Object} article - The article object containing details to render.
 * @returns {string} The HTML string for the article card.
 */
function renderArticleCard(article) {
  return `
    <a tabindex="0"
      href="${article.url}"
      class="h-full flex flex-col items-stretch {% if grid %} p-offset {% endif %}"
      style="--aspect-ratio:9/10"
    >
      ${!article.image || article.image === '' ? window.strings.placeholders.article : `<img src="${article.image.src || article.image}" srcset="
        ${Shopify.getSizedImage(article.image.src, '1000x')} 1000w,
        ${Shopify.getSizedImage(article.image.src, '900x')} 900w,
        ${Shopify.getSizedImage(article.image.src, '800x')} 800w,
        ${Shopify.getSizedImage(article.image.src, '700x')} 700w,
        ${Shopify.getSizedImage(article.image.src, '600x')} 600w,
        ${Shopify.getSizedImage(article.image.src, '500x')} 500w,
        ${Shopify.getSizedImage(article.image.src, '400x')} 400w,
        ${Shopify.getSizedImage(article.image.src, '300x')} 300w,
        ${Shopify.getSizedImage(article.image.src, '200x')} 200w,
        ${Shopify.getSizedImage(article.image.src, '100x')} 100w" sizes="auto" alt="${article.name}" class="block w-full object-cover bg-product rounded-sm aspect-[var(--aspect-ratio)]">`}
      <div class="w-full flex items-start justify-between gap-gutter-sm text-sm text-scheme-links mt-sm mb-xs empty:hidden">
        ${article.tags && article.tags.length > 0 && article.tags[0] || ''}
      </div>
      <div class="flex flex-col items-start gap-xs">
        <div class="empty:hidden text-heading-sm tablet:text-heading-xs font-light text-scheme-links">
          ${article.name}
        </div>
        <div class="empty:hidden rte line-clamp-1 overflow-clip text-ellipsis">
          ${(article.excerpt || article.shortDesc || '').replace(/<\/[^>]+(>|$)/g, '').trim().split(' ').splice(0, 40).join(' ')}
        </div>
        <span class="cta">${window.strings.blog.read}</span>
      </div>
    </a>
  `;
}

/**
 * Renders an page card with various page details and interactions.
 *
 * @param {Object} page - The page object containing details to render.
 * @returns {string} The HTML string for the page card.
 */
function renderPageCard(article) {
  return renderArticleCard(article);
}
function groupCollection(collection) {
  const groupedCollection = collection.reduce((grouped, product) => {
    const groupId = product.itemGroupId || product.id;
    if (!grouped[groupId]) {
      grouped[groupId] = [];
    }
    grouped[groupId].push(product);
    return grouped;
  }, {});
  return groupedCollection;
}
function calculateDiscountPercentage(num1, num2) {
  const amount = Math.floor((num1 - num2) * 100 / num1);
  return amount + '%';
}

/***/ })

}]);
//# sourceMappingURL=klevu.js.map